import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "./styles/font/stylesheet.css";
import App from "@/App";

// Capture the install prompt early (it can fire before React mounts) for "Add to Home Screen"
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__deferredInstallPrompt = e;
  window.dispatchEvent(new Event("tt-install-available"));
});
window.addEventListener("appinstalled", () => {
  window.__deferredInstallPrompt = null;
  window.dispatchEvent(new Event("tt-app-installed"));
});


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker to enable "Add to Home Screen" (PWA install)
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
